import { action, makeAutoObservable, observable } from 'mobx';

export type Dimensions = {
  width: number,
  height: number
}

export type Offset = {
  top: number,
  left: number,
  bottom: number,
  right: number,
}

class BarStore {
  @observable dimensions?: Dimensions = undefined;

  @observable offset?: Offset = undefined;

  @observable openLSButtonDimensions?: Dimensions = undefined;

  @observable openLSButtonOffset?: Offset = undefined;

  constructor() {
    makeAutoObservable(this);
  }

  @action setDimensions(dimensions: Dimensions): void {
    this.dimensions = dimensions;
  }

  @action setOffset(offset: Offset): void {
    this.offset = offset;
  }

  @action setOpenLSButtonDimensions(dimensions: Dimensions): void {
    this.openLSButtonDimensions = dimensions;
  }

  @action setOpenLSButtonOffset(offset: Offset): void {
    this.openLSButtonOffset = offset;
  }
}

export default new BarStore();
